/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import {
	View,
	Button,
	BoxSpinnerView,
	BoxInitEmptyView,
	BoxEmptyView,
} from '@components/atoms'
import { UserList } from '@components/molecules'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

import {
	useAppSelector,
	useAppDispatch,
	accessControlActions,
	ApiGetDataStatus,
	CrudType,
} from '@redux/index'
import { UserType } from '@schemas'

interface PropsType {
	status: ApiGetDataStatus
	userList: UserType[]
}

/** 그룹 멤버 — 헤어라인 행 목록, 바닥에 고스트 "멤버 수정" */
export const AccessGroupUserList = (props: PropsType) => {
	const { status, userList } = props

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const crud: CrudType = useAppSelector(state => state.auth.currentAccess)

	const onEditUsers = () => {
		reduxDispatch(accessControlActions.LEFT_MODAL_TAB_INDEX(1))
		reduxDispatch(accessControlActions.SHOW_SIDE_MODAL(true))
	}

	return (
		<View css={style}>
			{status === 'init' ? (
				<BoxInitEmptyView />
			) : status === 'loading' ? (
				<BoxSpinnerView />
			) : status === 'empty' ? (
				<BoxEmptyView isGrey={true} title="그룹 멤버가 없습니다." />
			) : status === 'ok' ? (
				<View className="userListOuter">
					<View className="userListView">
						<UserList
							status={status}
							userList={userList}
							showSearch={false}
							showDepartmentName={false}
							userInfoClassName="userInfo"
						/>
					</View>
					{crud.includes('U') && (
						<View className="memberEditView">
							<Button
								className="memberEditButton"
								variant="outlined"
								onClick={onEditUsers}
							>
								멤버 수정
							</Button>
						</View>
					)}
				</View>
			) : null}
		</View>
	)
}

const style = css({
	position: 'relative',
	overflow: 'hidden',
	width: '100%',
	height: '100%',
	padding: 0,
	fontFamily: boFont.ui,

	'.userListOuter': {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',

		'.userListView': {
			flex: 1,
			minHeight: 0,
			overflowY: 'auto',

			'.userInfo': {
				position: 'relative',
				background: 'transparent',
				border: 0,
				borderBottom: `1px solid ${mono.line}`,

				'.userInfoLeftAccessory': {
					position: 'absolute',
					right: '0.5rem',
					top: '0.7rem',
				},
			},
		},

		'.memberEditView': {
			flexShrink: 0,
			width: '100%',
			padding: '16px 0 0',

			'.memberEditButton': {
				width: '100%',
			},
		},
	},
})
